<template>
  <div>
    <h1 style="margin: 30px 0">总积分：{{ total }}</h1>
    <Table ref="selection" :columns="columns" :data="data1">
      <template slot-scope="{ row }" slot="createdAt">
        {{ formatTime(row.createdAt) }}
      </template>
      <template slot-scope="{ row }" slot="score">
        {{ row.score > 0 ? '+' + row.score : row.score }}
      </template>
      <template slot-scope="{ row }" slot="project">
        {{ row.project && row.project.name ? row.project.name : '-' }}
      </template>
      <template slot-scope="{ row }" slot="updatedAt">
        {{ row.status === 1 ? '-' : formatTime(row.updatedAt) }}
      </template>
    </Table>

    <div style="display: flex; align-items: center; margin-top: 20px">
      <span style="margin: 0 10px 0 0">总共{{ pagination.count }}个项目</span>
      <Page
        v-if="pagination.count"
        style="padding: 10px; background: #fff"
        class="page"
        @on-change="changePage"
        :current="pagination.pageIndex"
        :total="pagination.count"
        :page-size="pagination.pageSize"
        size="small"
        show-elevator
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    planId: String
  },
  data() {
    return {
      columns: [
        {
          title: '时间',
          key: 'createdAt',
          slot: 'createdAt',
          width: 160
        },
        {
          title: '积分变化',
          key: 'score',
          slot: 'score'
        },
        {
          title: '积分类型',
          key: 'scoreType'
        },
        {
          title: '帮扶项目',
          slot: 'project',
          width: 240
        },
        {
          title: '来源',
          key: 'source'
        },
        {
          title: '记录编号',
          key: 'recordNumber'
        },
        {
          title: '总积分',
          key: 'residualScore'
        }
      ],
      data1: [],
      pagination: {},
      total: 0
    };
  },
  watch: {
    planId: {
      deep: true,
      handler(newVal) {
        this.getTotal();
        this.getScore();
      }
    }
  },
  methods: {
    getTotal() {
      this.$axios
        .request({
          url: 'front/v1/company/help-plan-score/total',
          method: 'get',
          params: { planId: this.planId }
        })
        .then(res => {
          this.total = res.data.score;
        });
    },
    getScore(page = 1) {
      this.$axios
        .request({
          url: 'front/v1/company/help-plan-score-record',
          method: 'get',
          params: { pageIndex: page, planId: this.planId }
        })
        .then(res => {
          this.data1 = res.data.list || [];
          this.pagination = { count: res.data.count, pageIndex: res.data.pageIndex, pageSize: res.data.pageSize };
        });
    },
    changePage(page) {
      this.getScore(page);
    }
  }
};
</script>
